import { Button, CircularProgress } from "@mui/material";
import React from "react";

const CustomSubmitButton = (props) => {
    const { type, onSubmit, btnTitle, loading, sx = {} , disabled} = props
    return (
        <>
            <Button
                sx={{
                    width: "100%",
                    borderRadius: "15px",
                    background: "rgba(8, 85, 127, 1)",
                    padding: "10px 12px",
                    fontWeight: "500",
                    fontSize: "18px",
                    color: "white",
                    textTransform: "capitalize",
                    "&:hover": {
                        background: "rgba(8, 85, 127, 1)",
                        color: "white",
                    },
                    "&:disabled":{
                        background: "#ddd",
                        color: "white",
                    },
                    ...sx,
                    fontFamily: "Outfit",
                }}
                type={type}
                onClick={onSubmit}
                disabled={disabled}
            >
                {loading ? (
                    <CircularProgress
                        size={32}
                        sx={{
                            color: "#fff",
                        }}
                    />
                ) : (
                    btnTitle
                )}
            </Button>
        </>
    );
};

export default CustomSubmitButton;
